import { z } from 'zod';

import type { AssociatedType } from '@/models/AssociatedType.ts';
import type { ServiceUser } from '@/models/ServiceUser.ts';

import type { Authority } from './Authority.ts';
import type { Scheme } from './Scheme.ts';

export const AssociationSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.custom<AssociatedType>(),
  contactRelationship: z.string().nullable().optional(),
  raw: z
    .union([z.custom<ServiceUser>(), z.custom<Scheme>(), z.custom<Authority>()])
    .nullable()
    .optional(),
});

export type Association = z.infer<typeof AssociationSchema>;
